<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">
        Consider the ionization energies for a specific element below. Which of the ionization
        energies correspond to the removal of
      </p>

      <v-simple-table style="max-width: 341px" class="mb-4">
        <thead>
          <tr>
            <td />
            <td style="text-align: center; font-weight: bold">Value (kJ/mol)</td>
            <td style="text-align: center; font-weight: bold">Core Electron</td>
            <td style="text-align: center; font-weight: bold">Valence Electron</td>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <stemble-latex content="$\text{IE}_1$" />
            </td>
            <td style="text-align: center">
              <stemble-latex :content="IE1" />
            </td>
            <td style="align-content: center">
              <v-checkbox v-model="inputs.coreElectrons" value="IE1" class="pl-4" key="coreIE1" />
            </td>
            <td style="align-content: center">
              <v-checkbox
                v-model="inputs.valenceElectrons"
                value="IE1"
                class="pl-6"
                key="valenceIE1"
              />
            </td>
          </tr>
          <tr>
            <td>
              <stemble-latex content="$\text{IE}_2$" />
            </td>
            <td style="text-align: center">
              <stemble-latex :content="IE2" />
            </td>
            <td>
              <v-checkbox v-model="inputs.coreElectrons" value="IE2" class="pl-4" key="coreIE2" />
            </td>
            <td>
              <v-checkbox
                v-model="inputs.valenceElectrons"
                value="IE2"
                class="pl-6"
                key="valenceIE2"
              />
            </td>
          </tr>
          <tr>
            <td>
              <stemble-latex content="$\text{IE}_3$" />
            </td>
            <td style="text-align: center">
              <stemble-latex :content="IE3" />
            </td>
            <td>
              <v-checkbox v-model="inputs.coreElectrons" value="IE3" class="pl-4" key="coreIE3" />
            </td>
            <td>
              <v-checkbox
                v-model="inputs.valenceElectrons"
                value="IE3"
                class="pl-6"
                key="valenceIE3"
              />
            </td>
          </tr>
          <tr>
            <td>
              <stemble-latex content="$\text{IE}_4$" />
            </td>
            <td style="text-align: center">
              <stemble-latex :content="IE4" />
            </td>
            <td>
              <v-checkbox v-model="inputs.coreElectrons" value="IE4" class="pl-4" key="coreIE4" />
            </td>
            <td>
              <v-checkbox
                v-model="inputs.valenceElectrons"
                value="IE4"
                class="pl-6"
                key="valenceIE4"
              />
            </td>
          </tr>
          <tr v-if="versionNumber.value !== 1">
            <td>
              <stemble-latex content="$\text{IE}_5$" />
            </td>
            <td style="text-align: center">
              <stemble-latex :content="IE5" />
            </td>
            <td>
              <v-checkbox v-model="inputs.coreElectrons" value="IE5" class="pl-4" key="coreIE5" />
            </td>
            <td>
              <v-checkbox
                v-model="inputs.valenceElectrons"
                value="IE5"
                class="pl-6"
                key="valenceIE5"
              />
            </td>
          </tr>
          <tr v-if="versionNumber.value !== 1 && versionNumber.value !== 2">
            <td>
              <stemble-latex content="$\text{IE}_6$" />
            </td>
            <td style="text-align: center">
              <stemble-latex :content="IE6" />
            </td>
            <td>
              <v-checkbox v-model="inputs.coreElectrons" value="IE6" class="pl-4" key="coreIE6" />
            </td>
            <td>
              <v-checkbox
                v-model="inputs.valenceElectrons"
                value="IE6"
                class="pl-6"
                key="valenceIE6"
              />
            </td>
          </tr>
          <tr v-if="versionNumber.value === 4 || versionNumber.value === 5">
            <td>
              <stemble-latex content="$\text{IE}_7$" />
            </td>
            <td style="text-align: center">
              <stemble-latex :content="IE7" />
            </td>
            <td>
              <v-checkbox v-model="inputs.coreElectrons" value="IE7" class="pl-4" key="coreIE7" />
            </td>
            <td>
              <v-checkbox
                v-model="inputs.valenceElectrons"
                value="IE7"
                class="pl-6"
                key="valenceIE7"
              />
            </td>
          </tr>
          <tr v-if="versionNumber.value === 5">
            <td>
              <stemble-latex content="$\text{IE}_8$" />
            </td>
            <td style="text-align: center">
              <stemble-latex :content="IE8" />
            </td>
            <td>
              <v-checkbox v-model="inputs.coreElectrons" value="IE8" class="pl-4" key="coreIE8" />
            </td>
            <td>
              <v-checkbox
                v-model="inputs.valenceElectrons"
                value="IE8"
                class="pl-6"
                key="valenceIE8"
              />
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ElectronConfigurationInput from '../inputs/ElectronConfigurationInput';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';
import StembleLatex from '@/tasks/components/StembleLatex.vue';

export default {
  name: 'Question560',
  components: {
    StembleLatex,
    ChemicalLatex,
    ElectronConfigurationInput,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {
        coreElectrons: [],
        valenceElectrons: [],
      },
    };
  },
  computed: {
    versionNumber() {
      return this.taskState.getValueBySymbol('versionNumber').content ?? 5;
    },
    IE1() {
      if (this.versionNumber.value === 1) {
        return '$900$';
      } else if (this.versionNumber.value === 2) {
        return '$801$';
      } else if (this.versionNumber.value === 3) {
        return '$1,087$';
      } else if (this.versionNumber.value === 4) {
        return '$1,402$';
      } else {
        return '$1,314$';
      }
    },
    IE2() {
      if (this.versionNumber.value === 1) {
        return '$1,757$';
      } else if (this.versionNumber.value === 2) {
        return '$2,427$';
      } else if (this.versionNumber.value === 3) {
        return '$2,353$';
      } else if (this.versionNumber.value === 4) {
        return '$2,856$';
      } else {
        return '$3,383$';
      }
    },
    IE3() {
      if (this.versionNumber.value === 1) {
        return '$14,849$';
      } else if (this.versionNumber.value === 2) {
        return '$3,660$';
      } else if (this.versionNumber.value === 3) {
        return '$4,621$';
      } else if (this.versionNumber.value === 4) {
        return '$4,578$';
      } else {
        return '$5,301$';
      }
    },
    IE4() {
      if (this.versionNumber.value === 1) {
        return '$21,007$';
      } else if (this.versionNumber.value === 2) {
        return '$25,026$';
      } else if (this.versionNumber.value === 3) {
        return '$6,223$';
      } else if (this.versionNumber.value === 4) {
        return '$7,475$';
      } else {
        return '$7,469$';
      }
    },
    IE5() {
      if (this.versionNumber.value === 1) {
        return '$-$';
      } else if (this.versionNumber.value === 2) {
        return '$32,827$';
      } else if (this.versionNumber.value === 3) {
        return '$37,831$';
      } else if (this.versionNumber.value === 4) {
        return '$9,445$';
      } else {
        return '$10,990$';
      }
    },
    IE6() {
      if (this.versionNumber.value === 1) {
        return '$-$';
      } else if (this.versionNumber.value === 2) {
        return '$-$';
      } else if (this.versionNumber.value === 3) {
        return '$47,277$';
      } else if (this.versionNumber.value === 4) {
        return '$53,267$';
      } else {
        return '$13,327$';
      }
    },
    IE7() {
      if (this.versionNumber.value === 1) {
        return '$-$';
      } else if (this.versionNumber.value === 2) {
        return '$-$';
      } else if (this.versionNumber.value === 3) {
        return '$-$';
      } else if (this.versionNumber.value === 4) {
        return '$64,360$';
      } else {
        return '$71,330$';
      }
    },
    IE8() {
      if (this.versionNumber.value === 1) {
        return '$-$';
      } else if (this.versionNumber.value === 2) {
        return '$-$';
      } else if (this.versionNumber.value === 3) {
        return '$-$';
      } else if (this.versionNumber.value === 4) {
        return '$-$';
      } else {
        return '$84,078$';
      }
    },
  },
};
</script>
